import React, { useEffect, useState } from "react";

function diff(endsAt) {
  const ms = new Date(endsAt).getTime() - Date.now();
  return Math.max(0, ms);
}

export function useCountdown(endsAt) {
  const [ms, setMs] = useState(diff(endsAt));
  useEffect(() => {
    const t = setInterval(() => setMs(diff(endsAt)), 1000);
    return () => clearInterval(t);
  }, [endsAt]);
  return ms;
}

export default function Countdown({ endsAt, small, testid }) {
  const ms = useCountdown(endsAt);
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const ended = ms <= 0;
  const parts = ended ? "Ended"
    : d > 0 ? `${d}d ${String(h).padStart(2,"0")}h ${String(m).padStart(2,"0")}m`
    : `${String(h).padStart(2,"0")}:${String(m).padStart(2,"0")}:${String(sec).padStart(2,"0")}`;
  const hot = !ended && ms < 1000 * 60 * 60; // <1h
  return (
    <span
      data-testid={testid || "auction-countdown-timer"}
      className={`font-mono font-bold tracking-wider ${small ? "text-xs" : "text-sm"} ${
        ended ? "text-slate-400" : hot ? "text-red-600 dark:text-red-400" : "text-amber-600 dark:text-amber-400"
      }`}
    >
      {parts}
    </span>
  );
}
